import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./pages/login";
import { useContext } from "react";
import { UserContext } from "./context/UserContext";
import EventManagerLayout from "./layouts/EventManagerLayout";
import Home from "./pages/home";
import axios, { AxiosRequestConfig } from "axios";
import EventManagerPublicLayout from "./layouts/EventManagerPublicLayout";
import { Helmet } from 'react-helmet';

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // headers: {
  //   Authorization: `Bearer ${localStorage.getItem("loginToken")}`,
  // },
});

Axios.interceptors.request.use(
  (config: AxiosRequestConfig<any>) => {
    document.body.classList.add('loading-indicator');
    const token = localStorage.getItem("loginToken");
    if (token) {
      // @ts-ignore
      config.headers['Authorization'] = 'Bearer ' + token
    }
    // config.headers['Content-Type'] = 'application/json';
    return config
  },
  error => {
    Promise.reject(error)
  }
)

Axios.interceptors.response.use(response => {
    document.body.classList.remove('loading-indicator');
    return response;
  },
    error => {
      return Promise.reject(error);
  }
);

const App = () => {
  const { user, isLoading } = useContext(UserContext);

  if (isLoading) return <></>;

  return (
    <div className="App">
      <Helmet>
        <title>Hostess View - JBEvent</title>
      </Helmet>
      <Routes>
        {user && (
          <>
            <Route path="/" element={<Home />} />
            <Route path="/:id/*" element={<EventManagerLayout />} />
          </>
        )}
        <Route path="/:id/counter" element={<EventManagerPublicLayout/>} />
        { !user && <Route path="/login" element={<Login/>} /> }
        <Route path="*" element={<Navigate to={user ? '/':'/login'} />} />
        {/* <Route path="*" element={<Page404 />} /> */}
      </Routes>
    </div>
  );
};

export default App;
